module.exports = __webpack_public_path__ + "static/media/gongcheng4.bf120031.png";